import BaseComponent from "../../redare/components/BaseComponent";
import {Form, Input, Modal, Select} from "antd";
import React from "react";
import UserPresenter from "../../.gen/presenter/UserPresenter";
import PlatformPresenter from "../../.gen/presenter/PlatformPresenter";

export default class UserRoleForm extends BaseComponent {

    static defaultProps = {
        parentComponent:undefined
    }

    constructor(props) {
        super(props);
        this.state = {
            modalVisible:false,
            showLoading:false,
            userId:undefined
        }
        this.userPresenter = new UserPresenter(this);
        this.platformPresenter = new PlatformPresenter(this)
    }

    _getUserDetailInfo(userId) {
        this.userPresenter.getUser(
            {accountId: userId},
            {},
            (result) => {
                let {data} = result;
                if (data) {
                    this._getRoleByPlatform(data.platform);
                    let roleIds = data.roleIds.split(",");
                    this.form.setFieldsValue({
                        name: data.name,
                        orgName: data.orgName,
                        roleIds: roleIds
                    })
                }
            },
            () => {
            }
        )
    }

    _getRoleByPlatform(platform) {
        this.platformPresenter.findPlatformRoleList(
            {platform: platform},
            {},
            (result) => {
                let {data} = result;
                if (data) {
                    this.setState({roleList: data});
                }
            }
        )
    }

    _onModifyRoleConfirmClick(){
        let {userId} = this.state;
        this.form.validateFields().then(values=>{
            console.log(values);
            
            this.setState({showLoading:true});
            values.accountId = userId;
            values.replace = true;
            this.userPresenter.updateUserRole(
                values,{},
                ()=>{
                    this.toastSuccess("操作成功");
                    this.props.parentComponent._reloadUserMember();
                    this._hide();
                },
                ()=>{
                    this.setState({showLoading:false});
                }
            );
        }).catch(errorInfo=>{
            this.setState({showLoading:false});
        });
    }

    _show(userId){
        this.setState({modalVisible:true,userId})
        this._getUserDetailInfo(userId);
    }

    _hide(){
        this.setState({modalVisible:false,showLoading:false})
    }

    render() {
        let {modalVisible,showLoading,roleList} = this.state;
        let selectRole = [];
        if (roleList && roleList.length > 0) {
            roleList.map(item => {
                selectRole.push(
                    <Select.Option key={item.roleId} value={item.roleId+""}>{item.name}</Select.Option>
                )
            })
        }
        return (
            <Modal
                title="修改角色"
                visible={modalVisible}
                onOk={() => this._onModifyRoleConfirmClick()}
                onCancel={() => this._hide()}
                confirmLoading={showLoading}
                destroyOnClose={true}
                maskClosable={false}
                centered={true}
                okText={'保存'}
                cancelText={'取消'}
            >
                <Form ref={(o)=>this.form=o} className="add-form margin-bottom" labelAlign='right' labelCol={{span: 4}}
                      wrapperCol={{span: 18}}>
                    <Form.Item label="姓名" name="name" rules={[{required: false, message: '姓名不能为空'}]}>
                        <Input placeholder="请输入" autoComplete="off" disabled={true}/>
                    </Form.Item>
                    <Form.Item label="角色名称" name="roleIds" rules={[{required: true, message: '角色名称不能为空'}]}>
                        <Select placeholder="请选择" allowClear mode={"multiple"}>
                            {selectRole}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }

}
